import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import CompactLayout from 'src/layouts/compact';

const NotFoundView = lazy(() => import('src/sections/error/not-found-view'));
const TokenExpiredView = lazy(() => import('src/sections/error/TokenExpiredView'));

export const mainRoutes = [
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [
      { path: '404', element: <NotFoundView /> },
      { path: 'token-expired', element: <TokenExpiredView /> },
    ],
  },
];
